import api, {PaginatedResult} from "../../api";
import {supabase} from "../../supabase";
import {GridState} from "../../libs/grid_state_reducers";
import {RegFilters} from "./registrations/reg_grid_slice";

export const analyticsApi = api.injectEndpoints({
    endpoints: (build) => ({
        getRegByOperation: build.query<PaginatedResult<any>, GridState & RegFilters>({
            queryFn: async (args) => {
                let q = supabase
                    .from("registration")
                    .select("workTask(*), id.count(),ElapsedTime.sum()", {count: "exact"})
                makeFilters(q, args)
                const {data, count, error} = await q.range(0, 10000);

                if (error) return {error};

                return {data: {result: data, count}}
            },
            providesTags: []
        }),
        getRegByWorker: build.query<PaginatedResult<any>, GridState & RegFilters>({
            queryFn: async (args) => {
                let q = supabase
                    .from("registration")
                    .select("worker(*), id.count(),ElapsedTime.sum()", {count: "exact"})
                makeFilters(q, args)
                const {data, count, error} = await q.range(0, 10000);

                if (error) return {error};

                return {data: {result: data, count}}
            },
            providesTags: []
        }),
        getRegByDn: build.query<PaginatedResult<any>, GridState & RegFilters>({
            queryFn: async (args) => {
                let q = supabase
                    .from("registration")
                    .select("workOrder(*), id.count(),ElapsedTime.sum(), StartTime.min(), EndTime.max())", {count: "exact"})
                makeFilters(q, args)
                const {data, count, error} = await q.range(0, 10000);

                if (error) return {error};

                return {data: {result: data, count}}
            },
            providesTags: []
        }),
        getRegByMachine: build.query<PaginatedResult<any>, GridState & RegFilters>({
            queryFn: async (args) => {
                let q = supabase
                    .from("registration")
                    .select("machine(*),id.count(),ElapsedTime.sum()", {count: "exact"})
                makeFilters(q, args)
                const {data, count, error} = await q.range(0, 10000);

                if (error) return {error};

                return {data: {result: data, count}}
            },
            providesTags: []
        }),
        getRegByCustomer: build.query<PaginatedResult<any>, GridState & RegFilters>({
            queryFn: async (args) => {

                let q = supabase
                    .from("registration")
                    .select("workOrder(buyerCity, buyerCode, buyerCountry, " +
                        "buyerDocumentID, buyerEMail, buyerLastName, buyerMobilePhone, buyerName," +
                        "buyerName1, buyerPhone, buyerPostalCode, buyerStreet, buyerTaxNumber, " +
                        "buyertFirstName, buyerVatRegistration),id.count(),ElapsedTime.sum()", {count: "exact"})

                makeFilters(q, args)
                const {data, count, error} = await q.range(0, 10000);

                if (error) return {error};

                return {data: {result: data, count}}
            },
            providesTags: []
        })
    })
})

export const {
    useGetRegByOperationQuery,
    useGetRegByWorkerQuery,
    useGetRegByDnQuery,
    useGetRegByMachineQuery,
    useGetRegByCustomerQuery
} = analyticsApi;


function makeFilters(q: any, args: GridState & RegFilters) {
    if (args.worker.length > 0) {
        q = q.in("WorkerID", args.worker.map(i => i.id))
    }
    if (args.machine.length > 0) {
        q = q.in("MachineID", args.machine.map(i => i.id))
    }
    if (args.product.length > 0) {
        q = q.in("ProductID", args.product.map(i => i.id))
    }
    if (args.operation.length > 0) {
        q = q.in("OperationID", args.operation.map(i => i.id))
    }
    if (args.partner.length > 0) {
        q = q.in("workOrder.buyerDocumentID", args.partner.map(i => i.documentID)).not("registration.workOrder", "is", null)
    }
    if (args.workOrder.length > 0) {
        q = q.in("WorkOrderID", args.workOrder.map(i => i.id))
    }
    if (args.user.length > 0) {
        q = q.in("CreatedByID", args.user.map(i => i.id))
    }

    if (args.startTime) {
        q = q.gte("StartTime", args.startTime)
    }
    if (args.endTime) {
        q = q.lt("EndTime", args.endTime)
    }
    q.eq("Status", "RegFinished")

}